# Do we need this "progress" provider?  Doesn't get used here, doesn't get passed through anywhere else.

angular.module("avant.customer_applications.controllers").controller "CustomerApplicationsRatesTermsCtrl", [
  "$scope", "$rootScope", "$timeout", "$location", "$controller", "progress", "ConfigService", "CustomerApplicationService", "ApplicationService", "ProductService", "AvantErrorService", "$window", "$element",
  ($scope, $rootScope, $timeout, $location, $controller, progress, ConfigService, CustomerApplicationService, ApplicationService, ProductService, AvantErrorService, $window, $element) ->

    $scope.page = "rates_terms"
    $scope.has_loan_value_to_display = false
    if $scope.product?
      $scope.product.lock_product_watch = false

    $scope.$emit('customer_application:data', ApplicationService.data)
    angular.extend($scope, $controller('CustomerApplicationsMixinCtrl', {$scope: $scope, CustomerApplicationService: CustomerApplicationService, ApplicationService: ApplicationService}))

    ProductService.getDetails(ApplicationService.data.customer_application.id).then( ->
      $scope.trackVisit()
      # tracking specifically for the values when this page is first loaded
      $scope.$emit('customer_application:app_path', if $scope.is_variant('rates_terms_view', 'three_option') then 'three_option' else 'slider')
      $scope.registerNeuroIdSliderTracking() if $scope.startNeuroIdTracking && $scope.config.credit_policy_owner != 'pagaya'
    , (error) ->
      $scope.trackVisit()
      $timeout(->
        $scope.page_error = true
        $scope.$emit "hard_reload_page", true
      , 1000)
    )

    $scope.$on "$viewContentLoaded", ->
      $scope.tealiumView("#{$scope.page}_view", { application_page: $scope.page })
      # Calling the following method has no effect unless NeuroID is enabled
      $scope.recordNeuroIdCheckpoint("page1_complete")

    $scope.isCounterOffer = ->
      ProductService.data.has_counter_offer

    $scope.custom_quote_update = ->
      if $scope.product.custom_quote?.amount?
        ProductService.update(ApplicationService.data.customer_application.id, requested_amount: parseInt($scope.product.custom_quote.amount, 10))

    $scope.hasMaximumCashOutAmount = ->
      $scope.customer_application.max_cash_out_amount

    $scope.autoRefinanceSavingsAvailable = ->
      $scope.customer_application.auto_refinance && _.some($scope.product.loans, (loan) -> loan.monthly_savings > 0)

    $scope.posAppOnRiskBasedPricing = ->
      # this is only used for TD POS as of v5.3 to determine which view to show customers
      # it is called on the rates_terms template for TD POS in avant-basic.
      $scope.point_of_sale.on_risk_based_pricing

    $scope.loanOptionsHaveLoaded = ->
      # This controls whether the header and form are rendered. It should only
      # return false if the loan options have never been loaded; otherwise the
      # entire page will be rerendered when the requested amount changes.
      $scope.loan_options_have_loaded =
        $scope.loan_options_have_loaded || $scope.product?.loans?.length > 0

    $scope.lowBorrowRange = -> !!$scope.product?.low_borrow_range

    $scope.minimumApr = ->
      aprs = _.map($scope.product.loans, (loan) -> loan.apr)
      _.min(aprs)

    hasLowerApr = ->
      # Memoize this to prevent the header from changing when loan options are
      # reloaded
      return $scope.hasLowerApr if $scope.hasLowerApr
      return false unless $scope.loanOptionsHaveLoaded() && $scope.refinance?.apr
      existingApr = Math.round($scope.refinance.apr * 10000) / 10000
      $scope.hasLowerApr = $scope.minimumApr() < existingApr

    hasAdditionalFunds = ->
      # Refinancing products with no additional funds currently do not exist in
      # production. Once this feature exists on the backend, we need to revise
      # this code and verify the UI works correctly.
      true

    $scope.lowerAprOnly = ->
      hasLowerApr() && !hasAdditionalFunds()
    $scope.additionalFundsOnly = ->
      hasAdditionalFunds() && !hasLowerApr()
    $scope.lowerAprAndAdditionalFunds = ->
      hasLowerApr() && hasAdditionalFunds()

    $scope.$watch 'product.selected_loan', (newValue, oldValue) ->
      $scope.selected_loan_term = newValue.term if newValue

    $scope.$watch 'product.loans', (newValue, oldValue) ->
      if !_.isEmpty(newValue) && $scope.product?
        initial_loan = initialSelectedOption(newValue)
        if initial_loan?
          $scope.select_loan(initial_loan)

    initialSelectedOption = (loans) ->
      # When the page loads, select the default term based on the
      # product. If the customer has selected a loan term and changes
      # the loan amount, select the same term when the product options
      # are returned, if they exist. If they are a post lead customer and
      # partner wants to use selected term from redirect link, show those terms,
      # or if partner wants max term displayed.  If not, select nothing and prompt
      # the user to choose a new term.
      #
      # This method returns a loan object, or null if none are available.
      if $scope.selected_loan_term
        return findLoanFromTerm(loans, $scope.selected_loan_term) || findLoanWithMaxTerm(loans)
      else if $scope.config.use_post_lead_selected_loan_term && $scope.leadWelcomeInfo?.isPostLead
        return findLoanFromTerm(loans, $scope.product.term_int) || findLoanWithMaxTerm(loans)
      else if $scope.config?.max_term_as_default_loan_option
        return findLoanWithMaxTerm(loans)
      else if (term = $scope.config?.preselected_term?[$scope.customer_application.product_type]) != null
        if term == 0
          return _.min(loans, (loan) -> loan.term)
        else
          return (_.last(_.filter(loans, (loan) -> loan.term == term)) || null)
      else
        return null

    findLoanFromTerm = (loans, term) ->
      return _.findWhere(loans, term: term)

    findLoanWithMaxTerm = (loans) ->
      return _.max(loans, (loan) -> loan.term)

    canSubmit = ->
      if $scope.requestedLoanAmountError
        $element.find($scope.inputUsedForUpdate)?.focus()
        false
      else
        true

    $scope.submit = ->
      if canSubmit()
        $scope.$emit 'conversion:action', 'submit', 'rates_terms'

        followSubmit = ->
          if $scope.testB
            $scope.product.lock_product_watch = true
            $scope.updatingProduct = true
            $scope.quietUpdate().then ->
              submitContinuance()
          else
            submitContinuance()

        if $scope.form.selected_rate || $scope.product.product_type == 'credit_card'
          if $scope.form.selected_rate
            # doing this in the controller as we can't set
            # a required field in the view for a hidden input
            $scope.form.selected_rate.$setValidity "custom", !!$scope.form.selected_rate.$viewValue
          $scope.checkValidations ->
            # validation success
            followSubmit()
        else
          followSubmit()

    submitContinuance = ->
      $scope.submitWrapper (response_data) ->
        $scope.redirectIfDifferentPage response_data, ->
          # some error occurred as page didn't change
          $scope.closeAllLoadingModals()
          $scope.updatingProduct = false
          $scope.showServerSideErrors(response_data.server_side_errors)
        true

    $scope.$watch 'product.current_term', (newValue, oldValue) ->
      if newValue != oldValue && newValue?
        $scope.updateProductInformation()

    $scope.$on 'product:data', (events, data) ->
      $scope.dataHasLoaded = true
      $scope.has_admin_fees = data.has_administration_fee
      if _.isObject(data) and data.product_type isnt 'credit_card'
        tier = data.tier
        term = parseInt(data.term, 10)

    $scope.$on 'conversion:action', (event, data) ->
      if data == "submit"
        # Used by GlobalWideMedia tracking pixel
        $scope.rates_terms_submission_attempted = true

    resetDisplayAmountErrorType = ->
      $scope.display_amount_error_type = null

    $scope.updateProductAndDisplayAmount = (new_requested_amount) ->
      $scope.updateProductAmount(new_requested_amount)
      $scope.display_amount = new_requested_amount
      resetDisplayAmountErrorType()

    $scope.validateAndUpdateLoanAmount = ->
      $scope.loanAmountUpdatedBySlider = false
      $scope.display_amount = $scope.display_amount.replace(/\D/g,'')

      if (parseInt($scope.display_amount) < $scope.product.minimum_requestable_amount) ||
         (parseInt($scope.display_amount) > $scope.product.maximum_requestable_amount) ||
         $scope.display_amount == ""
        $scope.display_amount_error_type = 'error_out_of_range'
      else if parseInt($scope.display_amount) not in $scope.product.requestable_loan_amounts
        $scope.display_amount_error_type = 'error_multiple'
      else
        resetDisplayAmountErrorType()
        $scope.product.selected_amount_index = $scope.product.requestable_loan_amounts.indexOf $scope.display_amount
        $scope.updateProductAmount($scope.display_amount)
]
